export default {
  messages: {
    en: {
      noData: `There are no items to display.`,
    },
  },
}
